var _Settings;
import { Fragment } from 'react';
import AlertCircle from '@crehana/icons/fill/AlertCircle';
import Settings from '@crehana/icons/outline/Settings';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LowQualityWarning = function LowQualityWarning(_ref) {
  var isXxs = _ref.isXxs;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("p", {
    className: "h-48 inline-flex items-center",
    children: [/*#__PURE__*/_jsx(AlertCircle, {
      className: "text-yellow-main fill-current flex-shrink-0 ".concat(isXxs ? 'mr-4' : 'mr-8'),
      size: 24,
      ignoreColor: true
    }), /*#__PURE__*/_jsx("span", {
      className: "text-yellow-lighter font-subtitle4",
      children: t('LOW_QUALITY_WARNING_TITLE')
    }), !isXxs && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        className: "font-body4 text-gray-main ml-4",
        children: t('LOW_QUALITY_WARNING_CTA')
      }), _Settings || (_Settings = /*#__PURE__*/_jsx(Settings, {
        className: "text-gray-main fill-current flex-shrink-0 ml-4",
        size: 20,
        ignoreColor: true
      }))]
    })]
  });
};
export default LowQualityWarning;